@if (isNewBrand()) {
  <div class="grid-col-12 grid-max-width pr-large-y select-language-grid">
    <div class="flex flex--column flex--middle flex--left-center form-column">
      <div class="form-container">
        <div class="dn-laptop-down ms-large-b">
          <fcom-icon
            class="finnair-logo text-icon-primary"
            [category]="IconLibrary.CUSTOM"
            [name]="CustomIcon.FINNAIR_LOGO"
          />
        </div>
        <div class="dn-laptop-up ms-large-b">
          <fcom-icon
            class="finnair-emblem text-icon-primary"
            [category]="IconLibrary.CUSTOM"
            [name]="CustomIcon.FINNAIR_EMBLEM"
          />
        </div>

        <fin-country-and-language-selector
          [useH1]="true"
          [prefill]="true"
          [showCloseButton]="false"
          [fullWidthSubmit]="false"
          (applySelection)="applySelection($event)"
        />

        <div class="ms-large-t font-body-small text-icon-secondary">Your country wasn't listed?</div>
        <a class="text-icon-primary font-body-small underline" href="/en">Go to the international site</a>
      </div>
    </div>
    <div class="image-column dn-laptop-down relative">
      <div class="content-image-radius block overflow-hidden">
        <fin-content-image
          [imageData$]="imageData() | finToObservable"
          [aspectRatio$]="aspectRatio() | finToObservable"
          [isLazyLoad]="false"
          [fetchPriority]="FetchPriorityEnum.high"
        />
      </div>
    </div>
  </div>
} @else {
  <div class="df-laptop-up landing-page pr-large-t">
    <div class="country-selector-wrapper">
      <div class="country-selector align-center">
        <fcom-icon
          class="finnair-logo nordic-blue-900-text text-icon-primary mr-large-y"
          [category]="IconLibrary.CUSTOM"
          [name]="CustomIcon.FINNAIR_LOGO"
        />
        <fin-country-and-language-selector
          [useH1]="true"
          [prefill]="false"
          [showCloseButton]="false"
          (applySelection)="applySelection($event)"
        />
        <div class="ms-large-t font-body-2 font-body-small">Your country wasn't listed?</div>
        <a class="nordic-blue-900-text text-icon-primary font-body-2 font-body-small" href="/en"
          >Go to the international site</a
        >
      </div>
    </div>
    @if (imageUrl(); as imageUrl) {
      <div class="image-wrapper dn-laptop-down" [ngStyle]="{ 'background-image': 'url(' + imageUrl + ')' }"></div>
    }
  </div>
}
